<template>
    <div class="grid grid-cols-1 gap-x-4 gap-y-3 py-3 sm:grid-cols-1">
        <BaseInputRadio
            v-model="account.compliance_profiles.esac.fatca_declaration.us_citizen_or_resident"
            name="fatca_declaration.us_citizen_or_resident"
            :options="yesNoOptions"
            :required="isRequiredNaturalComplianceProfileAttribute('fatca_declaration', 'us_citizen_or_resident')"
            :label="$t('fatca_declaration.us_citizen_or_resident')" />
        <InlineAlert
            v-if="account.compliance_profiles.esac.fatca_declaration.us_citizen_or_resident === 'yes'"
            class="mt-4"
            :title="$t('fatca_declaration.cannot_continue')"
            :description="$t('fatca_declaration.contact_support')"
            type="Error">
        </InlineAlert>
    </div>
</template>

<script setup lang="ts">
import { onUnmounted } from 'vue'
import InlineAlert from '../../../base/InlineAlert.vue'
import BaseInputRadio from '../../../base/BaseInputRadio.vue'
import {
    getNaturalWidgetFormValidationRules,
    initializeNaturalWidgetForm,
    isRequiredNaturalComplianceProfileAttribute,
} from './forms'
import { yesNoOptions } from '../../../../data'
import { usePersonalAccountDataState } from '../../../../utilities/account/useAccountDataPersonal'

const { naturalProfile: account } = usePersonalAccountDataState()

onUnmounted(() => {
    if (account.compliance_profiles.esac.fatca_declaration.us_citizen_or_resident === 'yes') {
        account.compliance_profiles.esac.fatca_declaration.us_citizen_or_resident = null
    }
})

initializeNaturalWidgetForm(getNaturalWidgetFormValidationRules('fatca_declaration'))
</script>
